import { Box } from '@mui/material';

import logo from '@/assets/sofar-logomark-blue.png';
import { MainContentLoaderContainer, MainContentLoaderMessage } from '@/components/loaders/loaders.styled';

interface MainContentLoaderProps {
    message?: string;
}

export const MainContentLoader = ({ message = 'Waiting for satellite connection...' }: MainContentLoaderProps) => {
    return (
        <MainContentLoaderContainer>
            <Box component="img" src={logo} alt="sofar ocean logo" />
            <MainContentLoaderMessage>{message}</MainContentLoaderMessage>
        </MainContentLoaderContainer>
    );
};
